import React, { useState, useRef, useEffect } from "react";
import { Button } from "../../../common/commonIndex";


const Weight = ({ handleNextEvent, formData, questionData }) => {
    const [weight, setWeight] = useState(formData?.answer || 164);
    // Refs for the spinner items
    const spinnerRefs = useRef([]);

    useEffect(() => {
        const element = spinnerRefs.current[weight - 75];
        if (element) {
            console.log('Scrolling to:', weight); // Debug log
            element.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
            });
        } else {
            console.warn('Element not found for weight:', weight); // Debug warning
        }

        setWeight(formData?.answer ? formData?.answer : 164);
        formData.answer = weight;
        formData.fkAnswerIds = weight;
    }, [weight, formData?.answer]);

   
    const handlePoundsChange = (value) => {
        setWeight(value);
        formData.answer = value;
        formData.fkAnswerIds = value;
    };
    // Handle form submission
    const handleSubmit = (e) => {
        // skip then 2 otherwise 1
        let skip = 1;
        
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getLocalStorageData = () => {
        const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
        return findlocalStorageData;
    }
    const setLocalStorageData = (data) => {
        if (data?.length > 0) {
            localStorage.setItem('listOfAnswer', JSON.stringify(data));
        }
    }

    const createArray = (start, end) => {
        if (start > end) {
            throw new Error("Start value cannot be greater than end value");
        }
        return Array.from({ length: end - start + 1 }, (_, index) => index + start);
    };

    // Example Usage
    const dynamicArray = createArray(75, 1000);
    let heightList = {
        weight: dynamicArray,
    }

    const getOpacityClass = (index, selectedIndex, totalItems) => {
        const distance = Math.abs(index - selectedIndex);
        if (distance === 0) return 'opacity-1'; // Selected item
        if (distance === 1) return 'opacity-0-5'; // Close to selected item
        if (distance === 2) return 'opacity-0-5'; // Slightly farther
        return 'opacity-0-25'; // Farther away
    }

    return (
        <div>
            <h3 className="title">{questionData?.question}</h3>
            <div className="weight-spinner eligibility questionnaire height-question position-relative">
                <div className={'selected-weight'}></div>
                <div className="spinners-container">
                    {Array.from({ length: 1000 - 75 + 1 }, (_, index) => index + 75).map((value, index) => (
                        <div
                            key={value}
                            className={`spinner-item ${value === weight ? 'selected' : ''} ${getOpacityClass(
                                index,
                                weight - 75,
                                10
                            )}`}
                            onClick={() => handlePoundsChange(value)}
                            ref={(el) => (spinnerRefs.current[index] = el)}
                        >
                            {value}
                        </div>
                    ))}
                </div>
                <span className="height-ft">lbs</span>
                {/* <Picker value={pickerValue} onChange={setPickerValue} wheelMode="natural" className="height-picker">
                {Object.keys(heightList).map((name, index) => (
                    <>
                        <Picker.Column key={name} name={name} className={`height-picker-column ${name}`}>
                            {heightList[name].map(option => (
                                <Picker.Item key={option} value={option} className={'height-picker-item'}>
                                    <p className={getActiveClass(pickerValue, name, option)}>{option}</p>
                                </Picker.Item>
                            ))}
                        </Picker.Column>
                        <span className={`height-${name} picker-item-selected-name text-capitalize cursor-pointer`}>{`lbs`}</span>
                        <div className={`height-${name}-selected-show`}></div>
                    </>
                ))}
            </Picker> */}
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider"></div>
                <div className="footer-content">
                    <div className="skip-eligibility"></div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default Weight;